<template>
  <div class="admin-login">
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <div class="logo">
            <img src="@/assets/images/logo.png" alt="Logo" />
          </div>
          <h1 class="login-title">Painel Administrativo</h1>
          <p class="login-subtitle">Sistema de Gestão de Concursos Públicos</p>
        </div>

        <div class="login-body">
          <form @submit.prevent="login" class="login-form">
            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-envelope"></i>
                E-mail
              </label>
              <input
                v-model="form.email"
                type="email"
                class="form-control"
                placeholder="Digite seu e-mail"
                required
                :disabled="loading"
              />
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-lock"></i>
                Senha
              </label>
              <div class="password-input">
                <input
                  v-model="form.senha"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Digite sua senha"
                  required
                  :disabled="loading"
                />
                <button
                  type="button"
                  class="password-toggle"
                  @click="togglePassword"
                  :disabled="loading"
                >
                  <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>

            <div class="form-actions">
              <button
                type="submit"
                class="btn-login"
                :disabled="!isFormValid || loading"
              >
                <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                <i v-else class="fas fa-sign-in-alt"></i>
                {{ loading ? 'Entrando...' : 'Entrar' }}
              </button>
            </div>

            <div class="login-footer">
              <button
                type="button"
                class="btn-recover"
                @click="recuperarSenha"
                :disabled="loading"
              >
                <i class="fas fa-key"></i>
                Esqueci minha senha
              </button>
            </div>
          </form>
        </div>

        <div class="login-footer-info">
          <p class="version-info">
            <i class="fas fa-info-circle"></i>
            Versão 1.0.0 - Sistema Administrativo
          </p>
        </div>
      </div>
    </div>

    <!-- Modal de Recuperação de Senha -->
    <div v-if="showRecoverModal" class="modal-overlay" @click="closeRecoverModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fas fa-key"></i>
            Recuperar Senha
          </h4>
          <button @click="closeRecoverModal" class="modal-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <p class="modal-text">
            Digite seu e-mail para receber uma nova senha temporária.
          </p>
          <div class="form-group">
            <input
              v-model="recoverEmail"
              type="email"
              class="form-control"
              placeholder="Digite seu e-mail"
              required
            />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeRecoverModal" class="btn btn-secondary">
            Cancelar
          </button>
          <button @click="sendRecoverEmail" class="btn btn-primary" :disabled="!recoverEmail">
            <i v-if="recoverLoading" class="fas fa-spinner fa-spin"></i>
            <i v-else class="fas fa-paper-plane"></i>
            {{ recoverLoading ? 'Enviando...' : 'Enviar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminLogin',
  data() {
    return {
      form: {
        email: '',
        senha: ''
      },
      showPassword: false,
      loading: false,
      showRecoverModal: false,
      recoverEmail: '',
      recoverLoading: false
    }
  },
  computed: {
    isFormValid() {
      return this.form.email && this.form.senha
    }
  },
  mounted() {
    // Verificar se já está logado
    const token = localStorage.getItem('admin-token')
    console.log('Token encontrado no mounted:', token) // Debug
    if (token) {
      console.log('Redirecionando para dashboard no mounted') // Debug
      // Usar router do Vue para redirecionamento sem hash
      this.$router.push('/admin/dashboard')
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    async login() {
      if (!this.isFormValid) return

      this.loading = true
      try {
        console.log('Iniciando login com:', this.form) // Debug
        const response = await axios.post('/ps/admin/login', this.form)
        
        console.log('Resposta do login:', response.data) // Debug
        
        if (response.data && response.data.token) {
          // Salvar token no localStorage
          localStorage.setItem('admin-token', response.data.token)
          console.log('Token salvo no localStorage:', response.data.token.substring(0, 20) + '...') // Debug
          
          // Salvar dados do usuário se disponíveis
          if (response.data.user) {
            localStorage.setItem('admin-user', JSON.stringify(response.data.user))
            console.log('Dados do usuário salvos:', response.data.user) // Debug
          }
          
          // Configurar header de autorização
          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
          
          this.$sweet.sweetSuccess('Login realizado com sucesso!')
          
          // Aguardar um pouco antes do redirecionamento para garantir que o token foi salvo
          setTimeout(() => {
            console.log('Tentando redirecionar para /admin/dashboard') // Debug
            // Usar router do Vue para redirecionamento sem hash
            this.$router.push('/admin/dashboard')
          }, 1000)
        } else {
          console.log('Token não encontrado na resposta:', response.data) // Debug
          this.$sweet.sweetMensagem('Credenciais inválidas!', 'error')
        }
      } catch (error) {
        console.error('Erro no login:', error)
        if (error.response?.status === 401) {
          this.$sweet.sweetMensagem('E-mail ou senha incorretos!', 'error')
        } else {
          this.$sweet.sweetMensagem('Erro ao realizar login. Tente novamente.', 'error')
        }
      } finally {
        this.loading = false
      }
    },
    recuperarSenha() {
      this.showRecoverModal = true
      this.recoverEmail = this.form.email
    },
    closeRecoverModal() {
      this.showRecoverModal = false
      this.recoverEmail = ''
    },
    async sendRecoverEmail() {
      if (!this.recoverEmail) return

      this.recoverLoading = true
      try {
        await axios.post('/ps/admin/recuperar-senha', {
          email: this.recoverEmail
        })
        
        this.$sweet.showSuccess('Nova senha enviada para seu e-mail!')
        this.closeRecoverModal()
      } catch (error) {
        console.error('Erro ao recuperar senha:', error)
        if (error.response?.status === 404) {
          this.$sweet.showError('E-mail não encontrado!')
        } else {
          this.$sweet.showError('Erro ao enviar e-mail. Tente novamente.')
        }
      } finally {
        this.recoverLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-login {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.login-container {
  width: 100%;
  max-width: 400px;
}

.login-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: slideInUp 0.6s ease-out;
}

.login-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 40px 30px;
  text-align: center;

  .logo {
    margin-bottom: 20px;
    
    img {
      height: 60px;
      width: auto;
    }
  }

  .login-title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .login-subtitle {
    font-size: 14px;
    opacity: 0.9;
    margin: 0;
  }
}

.login-body {
  padding: 40px 30px;
}

.login-form {
  .form-group {
    margin-bottom: 25px;
  }

  .form-label {
    display: flex;
    align-items: center;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    font-size: 14px;

    i {
      margin-right: 8px;
      color: #667eea;
      width: 16px;
    }
  }

  .form-control {
    width: 100%;
    padding: 12px 15px;
    border: 2px solid #e9ecef;
    border-radius: 10px;
    font-size: 16px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:focus {
      outline: none;
      border-color: #667eea;
      box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
    }

    &:disabled {
      background-color: #f8f9fa;
      opacity: 0.6;
    }
  }

  .password-input {
    position: relative;

    .password-toggle {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      background: none;
      border: none;
      color: #6c757d;
      cursor: pointer;
      padding: 5px;
      transition: color 0.3s ease;

      &:hover {
        color: #667eea;
      }

      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
}

.form-actions {
  margin-top: 30px;
}

.btn-login {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  &:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
  }

  &:disabled {
    background: #6c757d;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
}

.login-footer {
  margin-top: 20px;
  text-align: center;

  .btn-recover {
    background: none;
    border: none;
    color: #667eea;
    text-decoration: none;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: 0 auto;

    &:hover {
      color: #764ba2;
    }

    &:disabled {
      color: #6c757d;
      cursor: not-allowed;
    }
  }
}

.login-footer-info {
  background: #f8f9fa;
  padding: 20px 30px;
  text-align: center;
  border-top: 1px solid #e9ecef;

  .version-info {
    margin: 0;
    font-size: 12px;
    color: #6c757d;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 15px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  animation: slideInUp 0.3s ease-out;
}

.modal-header {
  padding: 20px 25px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 10px;

    i {
      color: #667eea;
    }
  }

  .modal-close {
    background: none;
    border: none;
    color: #6c757d;
    cursor: pointer;
    padding: 5px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.3s ease;

    &:hover {
      background: #f8f9fa;
    }
  }
}

.modal-body {
  padding: 25px;

  .modal-text {
    margin-bottom: 20px;
    color: #6c757d;
    line-height: 1.5;
  }
}

.modal-footer {
  padding: 20px 25px;
  border-top: 1px solid #e9ecef;
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    &.btn-secondary {
      background: #6c757d;
      color: white;

      &:hover {
        background: #5a6268;
      }
    }

    &.btn-primary {
      background: #667eea;
      color: white;

      &:hover:not(:disabled) {
        background: #5a6fd8;
      }

      &:disabled {
        background: #6c757d;
        cursor: not-allowed;
      }
    }
  }
}

/* Animações */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade */
@media (max-width: 480px) {
  .login-header {
    padding: 30px 20px;

    .login-title {
      font-size: 20px;
    }
  }

  .login-body {
    padding: 30px 20px;
  }

  .login-footer-info {
    padding: 15px 20px;
  }

  .modal-content {
    margin: 10px;
  }

  .modal-header,
  .modal-body,
  .modal-footer {
    padding: 20px;
  }
}
</style>
